export default "/images/b136ea30a84fc4363c28cc6df1051fef.avif";